import React from 'react';
import { TrendingUp, Users, Award, Clock } from 'lucide-react';
const SocialProof = () => {
  const stats = [{
    icon: TrendingUp,
    value: 'RM 50M+',
    label: 'Processed Monthly'
  }, {
    icon: Users,
    value: '500+',
    label: 'Malaysian Businesses'
  }, {
    icon: Award,
    value: '99.9%',
    label: 'Payment Accuracy'
  }, {
    icon: Clock,
    value: '4.8/5',
    label: 'Customer Satisfaction'
  }];
  return <section className="section" data-id="element-327">
      <div className="container" data-id="element-328">
        <div className="text-center mb-16" data-id="element-329">
          <h2 className="font-outfit font-bold text-3xl md:text-4xl mb-6" data-id="element-330">
            Trusted by Malaysian Businesses
          </h2>
          <p className="text-slate-grey text-lg max-w-3xl mx-auto" data-id="element-331">
            Join hundreds of companies that trust Settl with their bill
            payments.
          </p>
        </div>
        {/* Statistics Bar */}
        <div className="bg-light-sky rounded-xl p-8 mb-16" data-id="element-332">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-333">
            {stats.map((stat, index) => {
            const Icon = stat.icon;
            return <div key={index} className="flex flex-col items-center text-center" data-id="element-334">
                  <Icon className="h-8 w-8 text-settl-blue mb-3" data-id="element-335" />
                  <div className="font-space-mono text-3xl font-bold text-charcoal mb-1" data-id="element-336">
                    {stat.value}
                  </div>
                  <div className="text-slate-grey" data-id="element-337">{stat.label}</div>
                </div>;
          })}
          </div>
        </div>
        {/* Featured Testimonial */}
        <div className="max-w-4xl mx-auto" data-id="element-338">
          <div className="bg-white rounded-xl shadow-sm p-8 relative" data-id="element-339">
            <div className="flex flex-col md:flex-row items-center" data-id="element-340">
              <div className="mb-6 md:mb-0 md:mr-8" data-id="element-341">
                <div className="w-24 h-24 rounded-full overflow-hidden" data-id="element-342">
                  <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80" alt="CEO of TechVision Malaysia" className="w-full h-full object-cover" data-id="element-343" />
                </div>
              </div>
              <div data-id="element-344">
                <blockquote className="text-lg text-slate-grey italic mb-6" data-id="element-345">
                  "Settl has revolutionized how we handle our finances. We've
                  reduced our accounts payable workload by 70% and improved
                  vendor relationships with faster payments. The 30-day float
                  gives us the breathing room we need to optimize our cash flow.
                  It's an essential tool for any growing Malaysian business."
                </blockquote>
                <div data-id="element-346">
                  <div className="font-medium text-charcoal" data-id="element-347">David Lim</div>
                  <div className="text-sm text-slate-grey" data-id="element-348">
                    CFO, GrowTech Solutions Malaysia
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default SocialProof;